export interface IPersonLocation {
  name: string,
  lat: string,
  lon: string
}

export const AnaHouse: IPersonLocation = {
  name: 'Ana',
  lat: '41.565340',
  lon: '2.095401'
}

export const DidacHouse: IPersonLocation = {
  name: 'Dídac',
  lat: '41.549001',
  lon: '2.427316'
}